import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { apisiseci } from "../../api";
import { Priority } from "../../../@types/priority";
import { AxErrorResponse } from "../../../@types/axios-error-response";

export type PriorityCreateData = {
    nome: string;
    descricao: string;
    peso: number;
    ativo: boolean;
    cor_tag: string;
    cor_fonte: string;
    sigla_senha: string;
    icone: string | File;
};

export function usePriorityCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        Priority,
        AxiosError<AxErrorResponse>,
        PriorityCreateData
    >({
        mutationKey: ["priority", "create"],
        mutationFn: async (data) => {
            const payload = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                if (value instanceof File) {
                    payload.append(key, value);
                } else if (Array.isArray(value)) {
                    if (value.length === 1) {
                        payload.append(key, String(value[0]) + ',');
                    } else {
                        payload.append(key, String(value));
                    }
                } else {
                    payload.append(key, String(value));
                }
            });
            const response = await apisiseci.post<Priority>(
                '/cms/prioridades/', payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["priority", "list"] })

            toast.success("Prioridade cadastrada com sucesso!");
            history.push("/prioridades");
        },
        onError: (error) => {
            console.error("Error creating priority:", error);
            const data = error?.response?.data || {};

            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key]) && data[key].length > 0) {
                    toast.error(data[key][0]);
                } else if (typeof data[key] === "string") {
                    toast.error(data[key]);
                }
            });

            if (Object.keys(data).length === 0) {
                toast.error("Algo deu errado, tente novamente!");
            }
        },
    });

    return mutation;
}
